'use strict'

window.Backbone = require 'backbone'
Backbone.$ = window.$
require '../../modules/home/frontend/main'
require '../../node_modules/widget-layout-assets/coffee/wls'
require 'grpn-wolfhound-ui/lib/js/grpn-wolfhound-ui.js'
